/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /code/mall-fe/src/api/shop.ts
 * @Description: 购物车相关业务服务PAI
 *
 */
import { fetch } from 'libs/fetch';
/**
 * @description: 获取店铺信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @param {Object} option 其他配置信息
 * @return {*}
 */
export async function getShopInfo(shopSysNo, option: FetchOptions) {
  const res = await fetch('/api/mall/v1/shop/getShop', {
    method: 'POST',
    query: {
      sysNo: shopSysNo,
    },
    ...option,
  });
  return res;
}

export async function getSuggestSpuList(shopSysNo, levelCode) {
  const res = await fetch(`/api/mall/v1/mallui/shop/getSuggestSpuList/${shopSysNo}/${levelCode} `, {
    method: 'GET',
  });
  return res;
}

/**
 * @description: 获取商铺评价信息
 * @param {FetchOptions} option
 * @return {*} 商铺评价信息
 */
export async function getDynamicEvaluation(option: FetchOptions) {
  const res = await fetch(`/api/supplier/v1/supplier/perfDynamicEvaluation/search`, {
    method: 'POST',
    ...option,
  });
  return res;
}

/**
 * @description: 获取店铺信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @param {Object} option 其他配置信息
 * @return {*}
 */
export async function getShopInfoData(shopSysNo, option: FetchOptions) {
  const res = await fetch(`/api/mall/v1/mallui/shop/getShopInfoData/${shopSysNo}`, {
    method: 'GET',
    ...option,
  });
  return res;
}

export async function getTwoCategoryTreeList(shopSysNo) {
  const res = await fetch(`/api/mall/v1/mallui/shop/getTwoCategoryTreeList/${shopSysNo}`, {
    method: 'GET',
  });
  return res;
}

export async function getGoodsResult(option: FetchOptions) {
  const res = await fetch('/api/mall/v1/mallui/shop/getGoodsResult', {
    method: 'POST',
    ...option,
  });
  return res;
}

/**
 * @description: 获取店铺首页信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @param {number} shopSysNo 店铺编号
 * @return {*}
 */
export async function getShopIndexPage(option: FetchOptions, query, shopSysNo) {
  const res = await fetch(`/api/mall/v1/purchaser/shopPage/getShopIndexPage/${shopSysNo}`, {
    method: 'GET',
    query,
    ...option,
  });
  return res;
}
/**
 * @description: 获取店铺页面配置信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @param {number} shopSysNo 店铺编号
 * @return {*}
 */
export async function getShopPage(option: FetchOptions, query, sysNo) {
  const res = await fetch(`/api/mall/v1/purchaser/shopPage/getShopPage/${sysNo}`, {
    method: 'GET',
    query,
    ...option,
  });
  return res;
}
/**
 * @description: 获取店铺商户信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @param {number} shopSysNo 店铺编号
 * @return {*} 店铺商户信息
 */
export async function getShopProfilePage(option: FetchOptions, query, shopSysNo) {
  const res = await fetch(`/api/mall/v1/purchaser/shopPage/getShopProfilePage/${shopSysNo}`, {
    method: 'GET',
    query,
    ...option,
  });
  return res;
}
/**
 * @description: 获取店铺商户商品信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @return {*} 店铺商户商品信息
 */
export async function searchSpuList(option: FetchOptions) {
  const res = await fetch(`/api/mall/v1/mallSku/search`, {
    method: 'POST',
    ...option,
  });
  return res;
}
/**
 * @description: 获取高级店铺商品信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @return {*} 高级店铺商品信息
 */
export async function shopSearchSpuList(option: FetchOptions) {
  const res = await fetch(`/api/mall/v1/mallSku/searchAdvancedShopHomePage`, {
    method: 'POST',
    ...option,
  });
  return res;
}
/**
 * @description: 采购商获取店铺可查看商品信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @return {*} 店铺商品信息
 */
export async function shopPageSkuList(option: FetchOptions) {
  const res = await fetch(`/api/mall/v1/purchaser/shopPage/skuList`, {
    method: 'POST',
    ...option,
  });
  return res;
}
/**
 * @description: 采购商获取店铺可查看商品分类信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @return {*} 店铺商品分类信息
 */
export async function getShopPackageSkuList(option: FetchOptions) {
  const res = await fetch(`/api/mall/v1/mallSku/getShopPackageSkuList`, {
    method: 'POST',
    ...option,
  });
  return res;
}
/**
 * @description: 采购商获取店铺可查看商品信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @return {*} 店铺商品信息
 */
export async function getShopPageList(option: FetchOptions) {
  const res = await fetch(`/api/mall/v1/purchaser/shopPage/searchList`, {
    method: 'POST',
    ...option,
  });
  return res;
}
/**
 * @description: 采购商获取店铺可查看商品信息
 * @param {string} shopSysNo
 * @param {FetchOptions} option
 * @return {*} 店铺商品信息
 */
export async function checkSupplierLimit(shopSysNo, option: FetchOptions) {
  const res = await fetch(`/api/mall/v1/purchaser/trade/checkSupplierLimit/${shopSysNo}`, {
    method: 'GET',
    ...option,
  });
  return res;
}

export async function apiGetShopInfoBySkuSysNo(skuSysNo, option: FetchOptions) {
  return await fetch(`/api/mall/v1/shop/getShopInfoBySku?skuSysNo=${skuSysNo}`, {
    method: 'GET',
    ...option,
  });
}

// 收藏店铺
export type collectionParams = {
  productShopSysNo: string;
  productShopName: string;
  supplierSysNo: string;
  supplierName: string;
  areaCode: string;
};
export async function addShopCollect(option: collectionParams) {
  const res = await fetch('/api/mall/v1/purchaser/shopCollect/addShopCollect', {
    method: 'POST',
    json: option,
  });
  return res;
}

// 取消收藏店铺
export type cancelCollectionParams = {
  productShopSysNo: string;
};
export async function cancelShopCollect(option: cancelCollectionParams) {
  const res = await fetch('/api/mall/v1/purchaser/shopCollect/cancelShopCollect', {
    method: 'POST',
    json: option,
  });
  return res;
}

//浏览历史
export async function browserHistoryList(option: {
  pageNo: number;
  pageSize: number;
  productName: string;
}) {
  const res = await fetch('/api/mall/v1/purchaser/browseHistory/search', {
    method: 'POST',
    json: option,
  });
  return res;
}

//根据id删除商品浏览历史
export async function deleteHistory(option: { sysNo: number }) {
  const res = await fetch('/api/mall/v1/purchaser/browseHistory/delete', {
    method: 'POST',
    json: option,
  });
  return res;
}

//根据日期删除商品浏览历史
export async function deleteHistoryByDate(option: { browseDay: string }) {
  const res = await fetch('/api/mall/v1/purchaser/browseHistory/batchDelete', {
    method: 'POST',
    json: option,
  });
  return res;
}

//收藏的店铺
export async function getShopCollectList(option: { productShopName: string }) {
  const res = await fetch('/api/mall/v1/purchaser/shopCollect/getShopCollectList', {
    method: 'POST',
    json: option,
  });
  return res;
}

//删除收藏的店铺
export async function batchDeleteCollections(option: string[]) {
  const res = await fetch('/api/mall/v1/purchaser/shopCollect/deleteShopCollect', {
    method: 'POST',
    json: option,
  });
  return res;
}
